export default () => ({
    loadingState: false
});